import {
  CssVarsThemeOptions,
  PaletteMode,
  PaletteOptions,
} from '@mui/material/styles';

import { ucrPaletteColors } from '../constants/ucrPaletteColors';

const generatorColorsTheme: () => Record<PaletteMode, PaletteOptions> = () => {
  return Object.entries(ucrPaletteColors).reduce(
    (acc, [key, { light, dark }]) => {
      acc.light[key] = light;
      acc.dark[key] = dark;
      return acc;
    },
    { dark: {}, light: {} } as Record<PaletteMode, PaletteOptions>,
  );
};

export const createPalette: () => CssVarsThemeOptions = () => {
  const { light, dark } = generatorColorsTheme();
  const globalScheme = {
    text: {
      primary: light['text-black'],
      disabled: light['text-grey-300'],
    },
    error: {
      main: light['line-red-100'],
      light: light['line-red-100'],
      dark: light['line-red-100'],
    },
  };

  return {
    defaultColorScheme: 'light',
    colorSchemes: {
      light: { palette: { ...light, ...globalScheme } },
      dark: { palette: { ...dark, ...globalScheme } },
    },
  };
};
